window.onload = function() {  
  const loadMoreButton = document.getElementById("collection-load-more");
  const loadMoreSpinner = document.getElementById("collection-load-more-spinner");
  const searchLoadMore = document.getElementById("search-load-more");
  const productList = document.getElementById("product-list");
  const noResultsMessage = document.querySelector(".filter-no-results");
  const clearAllFilterElement = document.querySelector(".fot-clear-filter");
  const filterOptionElements = document.querySelectorAll(".filter-option");
  const mobileFiltersButton = document.querySelector(".fot-filter-show-mobile");
  const filtersElement = document.querySelector(".fot-filter");
  const filtersCloseAllElement = document.getElementById("filters-close-all");
  const filterNameElements = document.querySelectorAll(".filter-name");
  const filterNameElementsMobile = document.querySelectorAll(
      ".filter-name-mobile"
  );
  const searchElement = document.querySelector(".fot-search");
  const searchBoxElement = document.querySelector(".fot-search-box");
  const searchBoxCloseElement = document.querySelector(".search-box-right");
  const searchForm = document.getElementById("search-form");
  const searchInput = document.getElementById("search-input");
  const searchInputIcon = document.getElementById("search-input-icon");
  
  const mdBreakpoint = 768;
  
  const utils = {
      fetch: async body => {
          try {
              const response = await fetch(
                  "https://foptics-store.myshopify.com/api/2022-04/graphql.json",
                  {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/graphql",
                          "X-Shopify-Storefront-Access-Token":
                              "a04bde06dd19a0ac5a34c0c2ce21038f" // store this in some global settings ?
                      },
                      body
                  }
              );
              return await response.json();
          } catch (error) {
              console.log("utils.fetch:", error);
          }
      },
      generateProductsGraphQlQuery(query) {
          return `
              {
                  products(${query}) {
                      edges {
                          node {
                              id
                              title
                              onlineStoreUrl
                              tags
                              priceRange {
                                  minVariantPrice {
                                      amount
                                  }
                              }
                              featuredImage {
                                  url
                                  altText
                              }
                              images(first: 2) {
                                  edges {
                                      node {
                                          url
                                          altText
                                      }
                                  }
                              }
                          }
                      }
                      pageInfo {
                          hasNextPage
                          endCursor
                      }
                  }
              }
          `;
      },
      generateCollectionGraphQlQuery(handle, query) {
          return `{
              collectionByHandle(handle: "${handle}") ${this.generateProductsGraphQlQuery(
              query
          )}
          }`;
      },
      generateProductHtml(product) {
          const { title, onlineStoreUrl, priceRange, featuredImage, images } =
              product;
  
          const price = parseFloat(priceRange.minVariantPrice.amount).toFixed(2);
          let hoverImage = "";
          if(images.edges[1]){
            hoverImage = images.edges[1]["node"];
          }
          
          return `
              <li class="fot-grid--view-item" data-url="${onlineStoreUrl}" data-price="${price}">
                  <div class="grid-view-item fot-product-card">
                      <div class="fot-product-card__image" data-image-loading-animation>
                          <div class="image-wrapper">
                              <a class="fot-product-link" href="${onlineStoreUrl}">
                                  <img
                                      class="first-image"
                                      alt="${featuredImage.alt}"
                                      data-src="${featuredImage.url}"
                                      data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                                      data-aspectratio=""
                                      data-sizes="auto"
                                      data-image
                                      src="${featuredImage.url}"
                                  />
                                  ${hoverImage? `<img class="second-image" src="${hoverImage.url}"/>` : ''}
                              </a>
                          </div>
                      </div>
                      <div class="fot-product-cart-bottom">
                          <div class="fot-product-card__title" aria-hidden="true">
                              <a href="${onlineStoreUrl}">
                                  ${title}
                              </a>
                          </div>
                          <dl class="price price--listing">
                              <div class="price__regular">
                                  <dd>
                                      <span class="price-item price-item--regular">
                                          $${price}
                                      </span>
                                  </dd>
                              </div>
                          </dl>
                      </div>
                  </div>
              </li>
          `;
      },
      retrieveLoadMoreButtonElementDataAttributes() {
          return loadMoreButton.dataset;
      },
      retrieveSearchLoadMoreButtonDataAttributes() {
          return searchLoadMore.dataset;
      },
      hideElement(ele) {
          ele.classList.add("hide");
      },
      showElement(ele) {
          ele.classList.remove("hide");
      },
      isFilterOptionActive(ele) {
          return ele.classList.contains("active");
      },
      addActiveClassToFilter(ele) {
          ele.classList.add("active");
      },
      removeActiveClassFromFilter(ele) {
          ele.classList.remove("active");
      },
      showLoader() {
          const bodyEle = document.querySelector("body");
          bodyEle.classList.add("active");
      },
      removeLoader() {
          const bodyEle = document.querySelector("body");
          bodyEle.classList.remove("active");
      },
      capitaliseWord(word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
      },
      setEleTextContent(type, content) {
          const displayEle = document.querySelector(
              `.filters h3[data-name="${type}"] .filter-display`
          );
          const displayPrefixEle = document.querySelector(
              `.filters h3[data-name="${type}"] .filter-display-prefix`
          );
          const viewportWidth = window.innerWidth;
          const shouldDisplayFilterPrefix =
              viewportWidth < mdBreakpoint && content !== "" && type !== content;
          if (shouldDisplayFilterPrefix) {
              displayPrefixEle.classList.remove("d-none");
          } else {
              displayPrefixEle.classList.add("d-none");
          }
          displayEle.textContent = content;
      },
      openSearchBox() {
          searchBoxElement.classList.add("active");
      },
      closeSearchBox() {
          searchBoxElement.classList.remove("active");
      }
  };
  
  class Filters {
      #state = {
          colour: [],
          material: [],
          shape: [],
          occasion: [],
          size: [],
          nosepads: []
      };
      #isPriceAscending = undefined;
      #keyToTagPrefix = {
          colour: "Color name|",
          material: "Material name|",
          shape: "Shape name|",
          occasion: "Occasion name|",
          size: "Size name|",
          nosepads: "Nosepads name|"
      };
  
      get state() {
          return this.#state;
      }
  
      add(filter, value) {
          this.#state[filter.toLowerCase()].push(value);
      }
  
      remove(filter, value) {
          const valueIndexPosition =
              this.#state[filter.toLowerCase()].indexOf(value);
          this.#state[filter.toLowerCase()].splice(valueIndexPosition, 1);
      }
  
      format() {
          const tags = Object.entries(this.#state).map(
              ([filter, filterValues]) => {
                  const formattedFilterValues = filterValues.map(
                      value => `${this.#keyToTagPrefix[filter]}${value}`
                  );
                  return formattedFilterValues
                      .map(value => `tag:'${value}'`)
                      .join(" OR ");
              }
          );
          return tags.filter(tag => tag);
      }
  
      get isPriceAscending() {
          return this.#isPriceAscending;
      }
  
      set isPriceAscending(isAscending) {
          this.#isPriceAscending = isAscending;
      }
  
      get isActive() {
          const activeFilters = Object.entries(this.#state).filter(
              ([filter, filterValues]) => {
                  if (filterValues.length > 0) {
                      return filter;
                  }
              }
          );
          return activeFilters.length > 0;
      }
  
      clear() {
          this.#state = {
              colour: [],
              material: [],
              shape: [],
              occasion: [],
              size: [],
              nosepads: []
          };
          this.isPriceAscending = undefined;
      }
  }
  
  class Products {
      #filters;
      #hasNextPage = false;
      #endCursor = null;
  
      constructor(filters) {
          this.#filters = filters;
      }
  
      loadMore() {
          if (
              this.#filters.isActive ||
              this.#filters.isPriceAscending !== undefined
          ) {
              this.#loadMoreFilteredProducts();
              return;
          }
  
          this.#loadMoreCollectionProducts();
          return;
      }
  
      async #loadMoreFilteredProducts() {
          utils.hideElement(loadMoreButton);
          utils.showElement(loadMoreSpinner);
          await this.#getFilteredProducts(true);
      }
  
      async #loadMoreCollectionProducts() {
          utils.hideElement(loadMoreButton);
          utils.showElement(loadMoreSpinner);
  
          const { collectionHandle, productsPerPage } =
              utils.retrieveLoadMoreButtonElementDataAttributes();
  
          const productsPerPageInt = parseInt(productsPerPage);
          const query = this.#generateCollectionNextPageQuery(productsPerPageInt);
  
          const { edges, pageInfo } = await this.#getCollection(
              collectionHandle,
              query
          );
          const products = this.#endCursor ? edges : edges.slice(productsPerPage);
          const productNodes = products.map(edge => edge.node);
  
          this.#appendProducts(productNodes);
          this.#updateNextPageState(pageInfo);
          this.#toggleLoadMoreButtonAndSpinner();
      }
  
      async #getCollection(handle, query) {
          const graphqlQuery = utils.generateCollectionGraphQlQuery(
              handle,
              query
          );
          const response = await utils.fetch(graphqlQuery);
          const products = response.data.collectionByHandle.products;
          return products;
      }
  
      // collection object does not last product's cursor value
      #generateCollectionNextPageQuery(productsPerPage) {
          const numberOfProductsToGet = this.#endCursor
              ? productsPerPage
              : productsPerPage * 2;
          const productsQuery = `first: ${numberOfProductsToGet}`;
          const cursorQuery = this.#endCursor
              ? ` after: "${this.#endCursor}"`
              : "";
          return `${productsQuery}${cursorQuery}`;
      }
  
      #appendProducts(products) {
          const productsMarkup = products.map(product =>
              utils.generateProductHtml(product)
          );
          const combinedProductsMarkup = productsMarkup.join("");
          productList.insertAdjacentHTML("beforeend", combinedProductsMarkup);
      }
  
      #updateNextPageState(pageInfo) {
          const { hasNextPage, endCursor } = pageInfo;
          this.#hasNextPage = hasNextPage;
          if (hasNextPage) {
              this.#endCursor = endCursor;
          } else {
              this.#endCursor = null;
          }
      }
  
      #toggleLoadMoreButtonAndSpinner() {
          if (this.#hasNextPage) {
              utils.showElement(loadMoreButton);
          } else {
              utils.hideElement(loadMoreButton);
          }
          utils.hideElement(loadMoreSpinner);
      }
  
      filterByTag(ele) {
          utils.hideElement(searchLoadMore);
          if (utils.isFilterOptionActive(ele)) {
              this.#removeFilter(ele);
              return;
          }
          this.#addFilter(ele);
      }
  
      async #addFilter(ele) {
          const { type, value } = ele.dataset;
          utils.showLoader();
          utils.addActiveClassToFilter(ele);
  
          this.#filters.add(type, value);
          await this.#getFilteredProducts(false);
          this.#updateFilterTextContent(type);
          this.#toggleClearAllFilter();
  
          utils.removeLoader();
      }
  
      #updateFilterTextContent(type) {
          const filters = this.#filters.state[type.toLowerCase()].join(", ");
          const content = filters === "" ? type : filters;
          utils.setEleTextContent(type, content);
      }
  
      #toggleClearAllFilter() {
          if (
              this.#filters.isActive ||
              this.#filters.isPriceAscending !== undefined
          ) {
              utils.showElement(clearAllFilterElement);
          } else {
              utils.hideElement(clearAllFilterElement);
          }
      }
  
      async #removeFilter(ele) {
          const { type, value } = ele.dataset;
          utils.showLoader();
          utils.removeActiveClassFromFilter(ele);
  
          this.#filters.remove(type, value);
          await this.#getFilteredProducts(false);
          this.#updateFilterTextContent(type);
          this.#toggleClearAllFilter();
  
          utils.removeLoader();
      }
  
      async #getFilteredProducts(useCursor) {
          const { collectionHandle, productsPerPage } =
              utils.retrieveLoadMoreButtonElementDataAttributes();
          const productType = collectionHandle
              .split("-")
              .map(word => utils.capitaliseWord(word))
              .join(" ");
  
          const query = this.#generateProductsQuery(
              productType,
              productsPerPage,
              useCursor
          );
  
          const graphqlQuery = utils.generateProductsGraphQlQuery(query);
          const response = await utils.fetch(graphqlQuery);
          const { edges, pageInfo } = response.data.products;
          const products = edges.map(edge => edge.node);
  
          if (products.length === 0) {
              utils.showElement(noResultsMessage);
          } else {
              utils.hideElement(noResultsMessage);
          }
  
          if (useCursor) {
              this.#appendProducts(products);
          } else {
              this.#replaceProducts(products);
          }
  
          this.#updateNextPageState(pageInfo);
          this.#toggleLoadMoreButtonAndSpinner();
      }
  
      #generateProductsQuery(productType, productsPerPage, useCursor) {
          const productTypeAndTagsQuery =
              this.#generateProductTypeAndTagsQuery(productType);
          const sortKeyAndReverse = this.#generateSortKeyAndReverseOrder();
          const first = `first:${productsPerPage}`;
          // const first = `first:3`;
          const cursor = useCursor ? `after:"${this.#endCursor}"` : "";
          return `${first} ${sortKeyAndReverse} ${productTypeAndTagsQuery} ${cursor}`.trim();
      }
  
      #generateProductTypeAndTagsQuery(productType) {
          const formattedFiltersQuery = this.#filters
              .format()
              .map(filter => `(${filter})`)
              .join(" AND ");
  
          if (productType === "Eyewear") {
              if (formattedFiltersQuery === "") {
                  // return `query:"(tag:'All Eyewear')"`
                  return "";
              }
              // return `query:"${formattedFiltersQuery} AND (tag:'All Eyewear')"`;
              return `query:"${formattedFiltersQuery}"`;
          }
  
          if (formattedFiltersQuery === "") {
              return `query:"(product_type:'${productType}')"`;
          }
  
          return `query:"(product_type:'${productType}') AND ${formattedFiltersQuery}"`;
      }
  
      #generateSortKeyAndReverseOrder() {
          if (this.#filters.isPriceAscending === undefined) {
              return "sortKey:CREATED_AT reverse:true";
          }
          return `sortKey:PRICE reverse:${!this.#filters.isPriceAscending}`;
      }
  
      #replaceProducts(products) {
          const productsMarkup = products.map(product =>
              utils.generateProductHtml(product)
          );
          const combinedProductsMarkup = productsMarkup.join("");
          productList.innerHTML = combinedProductsMarkup;
      }
  
      async clearFilters() {
          utils.showLoader();
  
          this.#resetProductsState();
          this.#toggleClearAllFilter();
          this.#updateFiltersActiveState();
          this.#updateFiltersDisplayValue();
  
          const { collectionHandle, productsPerPage } =
              utils.retrieveLoadMoreButtonElementDataAttributes();
          const productsPerPageInt = parseInt(productsPerPage);
          const query =
              this.#generateCollectionFirstPageQuery(productsPerPageInt);
  
          const { edges, pageInfo } = await this.#getCollection(
              collectionHandle,
              query
          );
          const products = edges.map(edge => edge.node);
  
          this.#replaceProducts(products);
          this.#updateNextPageState(pageInfo);
          this.#toggleLoadMoreButtonAndSpinner();
  
          utils.removeLoader();
      }
  
      #resetProductsState() {
          this.#filters.clear();
          this.#hasNextPage = false;
          this.#endCursor = null;
      }
  
      #updateFiltersActiveState() {
          filterOptionElements.forEach(option => {
              utils.removeActiveClassFromFilter(option);
          });
      }
  
      #updateFiltersDisplayValue() {
          const filterKeys = Object.keys(this.#filters.state);
          filterKeys.push("Price");
          filterKeys.forEach(filterKey => {
              const filterDataNameAttributeValue =
                  utils.capitaliseWord(filterKey);
              utils.setEleTextContent(
                  filterDataNameAttributeValue,
                  filterDataNameAttributeValue
              );
          });
      }
  
      #generateCollectionFirstPageQuery(productsPerPage) {
          return `first: ${productsPerPage}`;
      }
  
      async filterByPrice(ele) {
          utils.showLoader();
          utils.hideElement(searchLoadMore);
          const { value } = ele.dataset;
          this.#filters.isPriceAscending = value === "Low to high";
  
          console.log('nextElementSibling >>', ele.nextElementSibling)
          console.log('previousElementSibling >>', ele.previousElementSibling)
  
          utils.removeActiveClassFromFilter(
              this.#filters.isPriceAscending
                  ? ele.nextElementSibling
                  : ele.previousElementSibling
          );
          utils.addActiveClassToFilter(ele);
          utils.setEleTextContent("Price", value);
          await this.#getFilteredProducts(false);
          this.#toggleClearAllFilter();
          utils.removeLoader();
      }
  
      async search() {
          const searchInputValue = searchInput.value.trim();
          if (searchInputValue !== "") {
              utils.closeSearchBox();
              utils.showLoader();
              utils.hideElement(loadMoreButton);
  
              const { productsPerPage } =
                  utils.retrieveSearchLoadMoreButtonDataAttributes();
              const query = this.#generateSearchQuery(
                  productsPerPage,
                  searchInputValue
              );
              const graphqlQuery = utils.generateProductsGraphQlQuery(query);
  
              const response = await utils.fetch(graphqlQuery);
              const { edges, pageInfo } = response.data.products;
              const products = edges.map(edge => edge.node);
  
              if (products.length === 0) {
                  utils.showElement(noResultsMessage);
              } else {
                  utils.hideElement(noResultsMessage);
              }
  
              this.#replaceProducts(products);
              this.#updateSearchLoadMoreButton(pageInfo);
  
              utils.removeLoader();
          }
      }
  
      #generateSearchQuery(productsPerPage, value) {
          return `first:${productsPerPage} sortKey:CREATED_AT reverse:true query:"${value}"`;
          // first:12 sortKey:CREATED_AT reverse:true query:"forest"
      }
  
      #updateSearchLoadMoreButton(pageInfo) {
          const { hasNextPage, endCursor } = pageInfo;
  
          utils.hideElement(loadMoreSpinner);
  
          if (hasNextPage) {
              searchLoadMore.dataset.cursor = endCursor;
              utils.showElement(searchLoadMore);
              return;
          }
  
          searchLoadMore.dataset.cursor = "";
          utils.hideElement(searchLoadMore);
      }
  
      async loadMoreFromSearch() {
          utils.hideElement(searchLoadMore);
          utils.showElement(loadMoreSpinner);
  
          const searchInputValue = searchInput.value.trim();
          const { productsPerPage, cursor } =
              utils.retrieveSearchLoadMoreButtonDataAttributes();
          const query =
              this.#generateSearchQuery(productsPerPage, searchInputValue) +
              ` after:"${cursor}"`;
          const graphqlQuery = utils.generateProductsGraphQlQuery(query);
  
  
          const response = await utils.fetch(graphqlQuery);
          const { edges, pageInfo } = response.data.products;
          const products = edges.map(edge => edge.node);
  
          this.#appendProducts(products);
          this.#updateSearchLoadMoreButton(pageInfo);
      }
  }
  
  const filters = new Filters();
  const products = new Products(filters);
  
  loadMoreButton.addEventListener("click", () => {
      products.loadMore();
  });
  
  filterOptionElements.forEach(option => {
      const isOptionTypePrice = option.dataset.type === "Price";
  
      if (isOptionTypePrice) {
          option.addEventListener("click", e => {
              const element = e.currentTarget;
              products.filterByPrice(element);
          });
      } else {
          option.addEventListener("click", e => {
              const element = e.currentTarget;
              products.filterByTag(element);
          });
      }
  });
  
  clearAllFilterElement.addEventListener("click", () => {
      products.clearFilters();
  });
  
  mobileFiltersButton.addEventListener("click", () => {
      filtersElement.style.left = 0;
     filtersElement.style.visibility = 'visible';
       filtersElement.style.opacity = 1;
      utils.closeSearchBox();
  });
  
  filtersCloseAllElement.addEventListener("click", () => {
      filtersElement.style.left = "-100%";
       filtersElement.style.visibility = 'hidden';
       filtersElement.style.opacity = 0;
  });
  
  filterNameElements.forEach(filterName => {
      filterName.addEventListener("click", e => {
          const element = e.currentTarget;
          const viewportWidth = window.innerWidth;
          if (viewportWidth < mdBreakpoint) {
              element.nextElementSibling.classList.add("mobile-active");
          }
      });
  });
  
  filterNameElementsMobile.forEach(filterName => {
      filterName.addEventListener("click", e => {
          const element = e.currentTarget;
          element.parentElement.parentElement.classList.remove("mobile-active");
      });
  });
  
  searchElement.addEventListener("click", () => {
      utils.openSearchBox();
      searchInput.focus();
  });
  
  searchBoxCloseElement.addEventListener("click", () => {
      utils.closeSearchBox();
  });
  
  searchForm.addEventListener("submit", e => {
      e.preventDefault();
      products.search();
  });
  
  searchInputIcon.addEventListener("click", () => {
      products.search();
  });
  
  searchLoadMore.addEventListener("click", () => {
      products.loadMoreFromSearch();
  });
}
function destroyAfterOneMinute() {

}

setTimeout(destroyAfterOneMinute, 60000);